import React from "react";
import {
  siFacebook, siInstagram, siGoogle, siWhatsapp, siTiktok, siYoutube, siPaypal, siWoocommerce, siMessenger,
  siX, siStripe, siTrustpilot, siGmail, siShopify, siEbay, siKlarna, siApplepay, siGooglepay, siSquare,
  siSumup, siXero, siQuickbooks, siGooglemaps, siTelegram, siPinterest, siSnapchat,
} from "simple-icons";
import { Mail, Phone, Globe, Store, MessageCircle, Linkedin, Users, Megaphone } from "lucide-react";

// Ordered: more specific keywords first (e.g. "google pay" before "google").
const BRANDS = [
  ["messenger", siMessenger], ["facebook", siFacebook], ["instagram", siInstagram], ["whatsapp", siWhatsapp],
  ["tiktok", siTiktok], ["youtube", siYoutube], ["paypal", siPaypal], ["woocommerce", siWoocommerce],
  ["woo", siWoocommerce], ["stripe", siStripe], ["trustpilot", siTrustpilot], ["gmail", siGmail],
  ["google pay", siGooglepay], ["google maps", siGooglemaps], ["google", siGoogle], ["shopify", siShopify],
  ["ebay", siEbay], ["klarna", siKlarna], ["apple pay", siApplepay], ["square", siSquare], ["sumup", siSumup],
  ["xero", siXero], ["quickbooks", siQuickbooks], ["telegram", siTelegram], ["pinterest", siPinterest],
  ["snapchat", siSnapchat], ["twitter", siX],
];
const GENERIC = [
  ["linkedin", Linkedin], ["email", Mail], ["e-mail", Mail], ["phone", Phone], ["call", Phone],
  ["website", Globe], ["web", Globe], ["online", Globe], ["walk", Store], ["showroom", Store], ["shop", Store],
  ["chat", MessageCircle], ["sms", MessageCircle], ["referral", Users], ["recommend", Users],
];

export function resolveBrand(name) {
  const n = (name || "").toLowerCase();
  const b = BRANDS.find(([k]) => n.includes(k));
  if (b) return { kind: "brand", icon: b[1] };
  if (/(^|\W)x(\W|$)/.test(n)) return { kind: "brand", icon: siX };
  const g = GENERIC.find(([k]) => n.includes(k));
  return { kind: "generic", Icon: g ? g[1] : Megaphone };
}

export function BrandIcon({ name, size = 16, mono = false, className = "", testid }) {
  const r = resolveBrand(name);
  if (r.kind === "generic") {
    return <r.Icon className={`shrink-0 text-slate-500 ${className}`} style={{ width: size, height: size }} aria-hidden="true" data-testid={testid} />;
  }
  return (
    <svg role="img" viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" className={`shrink-0 ${className}`}
      fill={mono ? "currentColor" : `#${r.icon.hex}`} data-testid={testid}>
      <path d={r.icon.path} />
    </svg>
  );
}
